// frontend/src/pages/PaychequeDetail/styles.ts
// Palette + reusable style objects for PaychequeDetail.

import type { CSSProperties } from "react";

// ── Palette ─────────────────────────────────────────────────────────────
export const BRAND = "#0F9599";
export const BRAND_DARK = "#0F6E56";
export const BRAND_SOFT = "#E1F5EE";
export const BRAND_SOFT_BORDER = "#B8E2D2";
export const TEXT_PRIMARY = "#111827";
export const TEXT_SECONDARY = "#6B7280";
export const TEXT_TERTIARY = "#9CA3AF";
export const BG_CARD = "#FFFFFF";
export const BG_PAGE = "#F9FAFB";
export const BORDER = "#E5E7EB";
export const WARNING = "#B45309";

// ── Reusable buttons ────────────────────────────────────────────────────
/** White-bg bordered button used for Close, Transaction journal, and secondary actions. */
export const outlineBtn: CSSProperties = {
  fontSize: 12,
  padding: "8px 16px",
  borderRadius: 5,
  background: "white",
  color: TEXT_PRIMARY,
  border: "0.5px solid " + BORDER,
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "inherit",
};

/** Small variant of outlineBtn with icon support. Used for "Make adjustment" trigger. */
export const outlineBtnSmall: CSSProperties = {
  fontSize: 12,
  padding: "6px 12px",
  borderRadius: 5,
  background: "white",
  border: "0.5px solid " + BORDER,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  color: TEXT_PRIMARY,
  fontWeight: 500,
  fontFamily: "inherit",
};

/** White bg with brand teal border + text. Used for "Transaction journal". */
export const brandOutlineBtn: CSSProperties = {
  fontSize: 12,
  padding: "8px 14px",
  borderRadius: 5,
  background: "white",
  color: BRAND,
  border: "0.5px solid " + BRAND,
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "inherit",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
};

/** Solid brand teal background with white text. Used for the primary "Print pay stub" action. */
export const primaryBtn: CSSProperties = {
  fontSize: 12,
  padding: "8px 16px",
  borderRadius: 5,
  background: BRAND,
  color: "white",
  border: "none",
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "inherit",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
};

// ── Dropdown ────────────────────────────────────────────────────────────
export const dropdownMenu: CSSProperties = {
  position: "absolute",
  right: 0,
  top: 36,
  background: "white",
  border: "0.5px solid " + BORDER,
  borderRadius: 8,
  padding: 4,
  width: 180,
  zIndex: 50,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

export const dropdownItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "7px 10px",
  borderRadius: 5,
  cursor: "pointer",
  fontSize: 12,
  color: TEXT_PRIMARY,
};